<template>
    <div style="padding-bottom: 40px">
        <M3Warn v-if="data && data.m3_project && data.m3_project.duplicate_sections && data.m3_project.duplicate_sections.includes('financial_request')" type="yellow" :text="'Această secțiune a fost duplicată din proiectul companiei ' + getCompanyName(data.m3_project.duplicate_company_id)"></M3Warn>
        <CFTitle title="16. Maturitatea proiectului"></CFTitle>
        <validation-observer #default="{ invalid }" ref="maturitatea_proiectului">
            <span class="display-none">{{ invalid }}</span>
            <div>
                <p class="subtitle">Aspecte tehnice ( plan de afaceri, concepere proiect, etc.)</p>
                <M3Warn type="yellow" text="Se descrie existența studiului/studiilor însoțitor/însoțitoare, dacă este cazul, stadiul obținerii aprobărilor pentru implementarea proiectului, (studiul de evaluare a impactului asupra mediului, autorizaţii/acorduri/avize, alte studii etc.). Alte elemente solicitate prin Ghid"></M3Warn>
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                >
                    <CFTextarea v-model="form.tehnic" :read-only="completed" :limit="1750"></CFTextarea>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </div>
            <div>
                <p class="subtitle">Aspecte administrative</p>
                <M3Warn type="yellow" text="Oferiți detalii cel putin privind autorizatiile necesare, cum ar fi EIM, aprobarea de dezvoltare, deciziile privind amenajarea teritoriului, achizitiile publice, etc.<br>Se va descrie stadiul obţinerii aprobărilor, autorizaţiilor, avizelor prevăzute de legislaţia în vigoare şi necesare pentru implementarea proiectului."></M3Warn>
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                >
                    <CFTextarea v-model="form.administrativ" :read-only="completed" :limit="1750"></CFTextarea>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </div>
            <div>
                <p class="subtitle">Aspecte financiare</p>
                <M3Warn type="yellow" text="(decizii de angajament in ceea ce priveste cheltuielile publice nationale, imprumuturi solicitate sau acordate, etc. - a se furniza referinte)"></M3Warn>
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                >
                    <CFTextarea v-model="form.financiar" :read-only="completed" :limit="1750"></CFTextarea>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </div>
            <div>
                <p class="subtitle">În cazul în care proiectul a început deja, indicați starea de evoluție a lucrărilor</p>
                <M3Warn type="yellow" text="In cazul in care proiectul a inceput deja, indicati starea de evolutie a lucrarilor<br>Se va evalua stadiul actual al lucrărilor derulate anterior (după caz)"></M3Warn>
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                >
                    <CFTextarea v-model="form.stare" :read-only="completed" :limit="1750"></CFTextarea>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </div>
        </validation-observer>
        <b-form-checkbox
            v-model="completed"
            switch
            size="lg"
            class="switch-box"
            style="float: right"
            @change="sendForm()"
        >Informațiile sunt complete și corecte</b-form-checkbox>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import CFTextarea from "./CFTextarea";
    import { BFormCheckbox } from "bootstrap-vue";
    import M3Warn from "../M3Warn";
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';

    export default {
        name: "CFMaturitateaProiectului",
        components: {
            CFTextarea,
            BFormCheckbox,
            CFTitle,
            M3Warn,
            ValidationProvider,
            ValidationObserver
        },
        props:{
            m3GrantApplication: {
                type: Object,
                default: null
            },
            data: null
        },
        data() {
            return {
                form: {
                    tehnic: '',
                    administrativ: '',
                    financiar: '',
                    stare: '',
                },
                completed: null,
            }
        },
        computed: {
            companies() {
                return this.$store.getters['m3Sketch/companies'];
            },
            isCompleted() {
                return this.$store.getters['finantare/progress'].includes('Maturitatea proiectului');
            },
        },
        watch: {
            isCompleted: {
                handler() {
                    this.completed = this.isCompleted;
                },
                deep: true,
                immediate: true
            },
            m3GrantApplication: {
                handler () {
                    if(this.m3GrantApplication && this.m3GrantApplication.maturitatea_proiectului){
                        this.form.tehnic= this.m3GrantApplication.maturitatea_proiectului.tehnic;
                        this.form.administrativ= this.m3GrantApplication.maturitatea_proiectului.administrativ;
                        this.form.financiar= this.m3GrantApplication.maturitatea_proiectului.financiar;
                        this.form.stare= this.m3GrantApplication.maturitatea_proiectului.stare;
                    }
                },
                deep: true
            },
        },
        mounted() {
            if(this.m3GrantApplication && this.m3GrantApplication.maturitatea_proiectului){
                this.form.tehnic= this.m3GrantApplication.maturitatea_proiectului.tehnic;
                this.form.administrativ= this.m3GrantApplication.maturitatea_proiectului.administrativ;
                this.form.financiar= this.m3GrantApplication.maturitatea_proiectului.financiar;
                this.form.stare= this.m3GrantApplication.maturitatea_proiectului.stare;
            } else {
                this.form.tehnic = 'Solicitantul a analizat modul in care tranzitia catre o economie verde ar conduce la o eficientizare a resurselor si un mod sustenabil de productie. Investitia are ca scop ameliorarea efectelor provocate de criza in contextul pandemiei de COVID-19 si al consecintelor sale sociale si va sprijini intreprinderea '+ JSON.parse(localStorage.getItem('currentM3Company')).name +' in a fi pregatita pentru o redresare verde si pentru a redeveni competitiva pe piata. \n' +
                    'De asemenea, produsul nou introdus a fost dezvoltat in urma unor analize aprofundate de impact. Inovarea consta in ____________________ si rezolva urmatoarea nevoie identificata in randul consumatorilor: _________________. Acesta va permite extinderea catre noi segmente de piata.\n'
                this.form.administrativ = 'Echipamentele prevazute spre achizitionare contribuie in mod substantial la atenuarea schimbarilor climatice sau adaptarea la schimbarile climatice. Acestea prezinta urmatoarele certificari recunoscute international: ___________________. Costul acestor echipamente a fost studiat si comparat, iar costul optim identificat se regaseste in cele doua oferte de pret atasate cererii de finantare. \n' +
                    'In ceea ce priveste produsul inovator propus, pentru acesta au fost obtinute brevetele: ______________.\n'
                this.form.financiar = 'Solicitantul a avansat demersurile pentru obtinerea finantarii care ii va permite sustinerea contributiei proprii eligibile din bugetul proiectului prin: ___________________. '
                this.form.stare = 'Vă rugăm detaliați'
            }
        },
        methods: {
            getCompanyName(id){
                let name = '';
                this.companies.forEach(company => {
                    if(Number(company.id) === Number(id))
                        name = company.name
                })

                return name;
            },
            sendForm(){
                if(this.completed){
                    this.$refs.maturitatea_proiectului.validate().then((e) => {
                        if (!e) {
                            this.completed = false
                            this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                        } else {
                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {maturitatea_proiectului: this.form})
                                .then( () => {
                                    this.$toast.success('Informațiile au fost salvate!')
                                    this.$emit('savedData')
                                    this.$store.dispatch('finantare/addToProgress', 'Maturitatea proiectului')
                                })
                        }
                    })
                }
                else{
                    this.$store.dispatch('finantare/removeFromProgress', 'Maturitatea proiectului')
                }
            }
        }
    }
</script>

<style scoped>
.subtitle{
  font-weight: bold;
  margin-top: 20px;
}
</style>
